import { render, staticRenderFns } from "./PlanCheck.vue?vue&type=template&id=4fee4923&scoped=true"
import script from "./PlanCheck.vue?vue&type=script&lang=js"
export * from "./PlanCheck.vue?vue&type=script&lang=js"
import style0 from "./PlanCheck.vue?vue&type=style&index=0&id=4fee4923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee4923",
  null
  
)

export default component.exports